var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入客户名",
      "clearable": "",
      "search": ""
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchtext,
      callback: function ($$v) {
        _vm.searchtext = $$v;
      },
      expression: "searchtext"
    }
  }), _c('div', {
    staticClass: "page flex-space-between"
  }, [_c('SelectUserDropDown', {
    attrs: {
      "selectedUser": _vm.selectedUser
    },
    on: {
      "selectUser": _vm.selectUser
    }
  }), _c('div', {
    staticClass: "flex-space-between"
  }, [_c('div', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCustomer
    }
  })], 1)], 1), _c('Row', {
    staticClass: "table-title",
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_vm._v(" 客户 ")]), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" 欠款 ")]), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v(" 收款 ")]), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v(" 销量 ")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "customer-wrapper"
  }, _vm._l(_vm.statViewC, function (salesStat) {
    var _vm$selectedCustomer, _salesStat$customer;
    return _c('div', {
      key: salesStat._id,
      staticClass: "customer-card",
      class: {
        selected: ((_vm$selectedCustomer = _vm.selectedCustomer) === null || _vm$selectedCustomer === void 0 ? void 0 : _vm$selectedCustomer._id) === ((_salesStat$customer = salesStat.customer) === null || _salesStat$customer === void 0 ? void 0 : _salesStat$customer._id)
      },
      on: {
        "click": function ($event) {
          return _vm.showCustomerDetail(salesStat.customer);
        }
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v(" " + _vm._s(salesStat.customer.name) + " ")]), _c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v(" " + _vm._s((salesStat.totalAccountsReceivable / 10000).toFixed(2)) + "万 "), _c('br'), _vm._v(" (" + _vm._s(salesStat.longestARMonthCount) + "个月) ")]), _c('Col', {
      attrs: {
        "span": "4"
      }
    }, [salesStat.receiveAfterSpecDate === 0 ? _c('span', {
      staticStyle: {
        "color": "lightgray"
      }
    }, [_vm._v("-")]) : _c('span', [_vm._v(_vm._s((salesStat.receiveAfterSpecDate / 10000).toFixed(2)) + "万")])]), _c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(" " + _vm._s(salesStat.vol) + " ")])], 1)], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }